'use strict';

/* ─── State ──────────────────────────────────────────────────── */
const state = {
  mySex:    null,   // 0 = בן, 1 = בת
  myYear:   null,   // integer 12–19
  myMonth:  null,   // integer 0–11
  hisSex:   null,
  hisYear:  null,
  hisMonth: null,
  actType:  null,   // '1'–'6'
  act:      null,   // action-code string
};

/* ─── DOM references ─────────────────────────────────────────── */
const $ = (id) => document.getElementById(id);
const els = {
  mySex:         $('my_sex'),
  myYear:        $('my_year'),
  myMonth:       $('my_month'),
  hisSex:        $('his_sex'),
  hisYear:       $('his_year'),
  hisMonth:      $('his_month'),
  actType:       $('act_type'),
  act:           $('act'),
  actAlt:        $('act_alt'),
  actPanel:      $('act-panel'),
  iwant:         $('iwant'),
  hewants:       $('hewants'),
  resultSection: $('result-section'),
  resultSummary: $('result-summary'),
  verdictCard:   $('verdict-card'),
};

/* ─── Helpers ────────────────────────────────────────────────── */
function isSet(v) { return v !== null && v !== undefined; }

function markError(el, on) {
  if (on) {
    el.classList.add('is-error');
    el.setAttribute('aria-invalid', 'true');
  } else {
    el.classList.remove('is-error');
    el.removeAttribute('aria-invalid');
  }
  // Non-color error indicator — update sibling .field-error if present (WCAG 1.4.1)
  const errorSpan = el.parentElement && el.parentElement.querySelector('.field-error');
  if (errorSpan) {
    if (on) {
      errorSpan.textContent = 'שדה חובה — נא לבחור ערך';
      errorSpan.classList.add('is-visible');
    } else {
      errorSpan.textContent = '';
      errorSpan.classList.remove('is-visible');
    }
  }
}

function addOpt(group, value, text) {
  const opt = document.createElement('option');
  opt.value = value;
  opt.textContent = text;
  group.appendChild(opt);
}

/* ─── Reset result ───────────────────────────────────────────── */
function resetResult() {
  els.resultSection.hidden = true;
  els.resultSummary.innerHTML = '';
  els.verdictCard.innerHTML   = '';
  els.verdictCard.className   = 'verdict-card';
}

/* ─── Populate specific act options ──────────────────────────── */
function showActs() {
  if (!isSet(state.actType) || !isSet(state.mySex) || !isSet(state.hisSex)) {
    els.actPanel.hidden = false;
    els.actAlt.hidden   = false;
    els.act.hidden      = true;
    return;
  }

  state.act = null;
  resetResult();

  // Clear optgroup contents — do NOT clear the whole select (that would orphan the optgroups)
  els.iwant.innerHTML   = '';
  els.hewants.innerHTML = '';

  // Remove the standalone placeholder option if it was inserted previously
  if (els.act.firstElementChild && els.act.firstElementChild.tagName === 'OPTION') {
    els.act.removeChild(els.act.firstElementChild);
  }

  // Re-insert placeholder at the top of the select
  const first = document.createElement('option');
  first.value = '';
  first.textContent = 'בחר אקט...';
  els.act.insertBefore(first, els.act.firstElementChild);

  els.act.hidden  = false;
  els.actAlt.hidden = true;
  els.actPanel.hidden = false;
  markError(els.act, true);

  const my  = state.mySex;   // 0=בן, 1=בת
  const his = state.hisSex;
  const hisTxt = his === 0 ? 'בן' : 'בת';

  switch (state.actType) {
    case '1': // מין וגינלי
      if (!my && his)  { // בן + בת
        addOpt(els.iwant,   '150', 'להחדיר את הפין שלי לפות של בת הזוג שלי');
        addOpt(els.hewants, '150', 'שאני אחדיר את הפין שלי לפות שלה');
        addOpt(els.iwant,   '150', 'להחדיר חפץ לפות של בת הזוג שלי');
        addOpt(els.hewants, '150', 'שאני אחדיר חפץ כלשהו לפות שלה');
        addOpt(els.iwant,   '150', 'להחדיר אצבעות לפות של בת הזוג שלי');
        addOpt(els.hewants, '150', 'שאני אחדיר אצבעות לפות שלה');
      }
      if (my && !his) { // בת + בן
        addOpt(els.iwant,   '160', 'שבן זוגי יחדיר את הפין שלו לפות שלי');
        addOpt(els.hewants, '160', 'להחדיר את הפין שלו לפות שלי');
        addOpt(els.iwant,   '160', 'שבן זוגי יחדיר חפץ לפות שלי');
        addOpt(els.hewants, '160', 'להחדיר חפץ לפות שלי');
        addOpt(els.iwant,   '160', 'שבן זוגי יחדיר אצבעות לפות שלי');
        addOpt(els.hewants, '160', 'להחדיר אצבעות לפות שלי');
      }
      if (!my && !his) { // בן + בן
        addOpt(els.iwant,   '-1', 'מין וגינלי אינו אפשרי בין שני בנים');
        addOpt(els.hewants, '-1', 'מין וגינלי אינו אפשרי בין שני בנים');
      }
      if (my && his) { // בת + בת
        addOpt(els.iwant,   '160', 'שבת זוגתי תחדיר חפץ לפות שלי');
        addOpt(els.hewants, '150', 'שאני אחדיר חפץ לפות של בת זוגתי');
        addOpt(els.iwant,   '160', 'שבת זוגתי תחדיר אצבעות לפות שלי');
        addOpt(els.hewants, '150', 'שאני אחדיר אצבעות לפות של בת זוגתי');
      }
      break;

    case '2': // מין אנאלי
      if (!my) {
        addOpt(els.iwant,   '151', `להחדיר את הפין שלי לפי הטבעת של ה${hisTxt} זוג שלי`);
        addOpt(els.iwant,   '151', `להחדיר חפץ לפי הטבעת של ה${hisTxt} זוג שלי`);
        addOpt(els.iwant,   '151', `להחדיר אצבעות לפי הטבעת של ה${hisTxt} זוג שלי`);
        if (!his) addOpt(els.hewants, '161', 'להחדיר את הפין שלו לפי הטבעת שלי');
        addOpt(els.hewants, '161', 'להחדיר חפץ לפי הטבעת שלי');
        addOpt(els.hewants, '161', 'להחדיר אצבעות לפי הטבעת שלי');
      }
      if (my && !his) {
        addOpt(els.iwant,   '161', 'שבן הזוג שלי יחדיר את הפין שלו לפי הטבעת שלי');
        addOpt(els.hewants, '161', 'להחדיר את הפין שלו לפי הטבעת שלי');
        addOpt(els.iwant,   '161', 'שבן הזוג שלי יחדיר חפץ לפי הטבעת שלי');
        addOpt(els.hewants, '161', 'להחדיר חפץ לפי הטבעת שלי');
        addOpt(els.iwant,   '161', 'שבן הזוג שלי יחדיר אצבעות לפי הטבעת שלי');
        addOpt(els.hewants, '161', 'להחדיר אצבעות לפי הטבעת שלי');
        addOpt(els.iwant,   '161', 'להחדיר אצבעות או חפץ לפי הטבעת של בן הזוג שלי');
        addOpt(els.hewants, '161', 'להחדיר אצבעות או חפץ לפי הטבעת של בן הזוג שלי');
      }
      if (my && his) {
        addOpt(els.iwant,   '161', 'שבת הזוג שלי תחדיר אצבעות/חפץ לפי הטבעת שלי');
        addOpt(els.hewants, '161', 'להחדיר אצבעות/חפץ לפי הטבעת שלי');
        addOpt(els.iwant,   '151', 'להחדיר אצבעות/חפץ לפי הטבעת של בת הזוג שלי');
        addOpt(els.hewants, '151', 'שאני אחדיר אצבעות/חפץ לפי הטבעת שלה');
      }
      break;

    case '3': // מין אוראלי
      if (!his) {
        addOpt(els.iwant, '161', 'למצוץ לבן זוג שלי');
      } else {
        addOpt(els.iwant, '119', 'לרדת לבת זוג שלי ללא החדרת הלשון או חפצים אחרים לפות שלה');
        addOpt(els.iwant, '150', 'לרדת לבת זוג שלי כולל החדרת לשון או חפצים אחרים לפות שלה');
      }
      if (my) {
        addOpt(els.hewants, '119', 'לרדת לי ללא החדרת הלשון או חפצים אחרים לפות שלי');
        addOpt(els.hewants, '150', 'לרדת לי כולל החדרת לשון או חפצים אחרים לפות שלי');
      } else {
        addOpt(els.hewants, '151', 'למצוץ לי');
      }
      addOpt(els.iwant,   '119', `ללקק את פי הטבעת של ה${hisTxt} זוג שלי ללא החדרת הלשון`);
      addOpt(els.hewants, '119', 'ללקק את פי הטבעת שלי ללא החדרת הלשון');
      addOpt(els.iwant,   '161', `ללקק את פי הטבעת של ה${hisTxt} זוג שלי כולל החדרת הלשון`);
      addOpt(els.hewants, '161', 'ללקק את פי הטבעת שלי כולל החדרת הלשון');
      break;

    case '4': { // יחסי מין ללא חדירה
      const pairLabel = (my && his) ? 'אחת עם השנייה' : 'אחד עם השני';
      addOpt(els.iwant,   '102', `לשכב ${pairLabel} כשאחד מאיתנו לבוש בבגדים`);
      addOpt(els.hewants, '102', `לשכב ${pairLabel} כשאחד מאיתנו לבוש בבגדים`);
      addOpt(els.iwant,   '103', `לשכב ${pairLabel} בלי בגדים אבל גם בלי חדירה`);
      addOpt(els.hewants, '103', `לשכב ${pairLabel} בלי בגדים אבל גם בלי חדירה`);
      if (!my)  addOpt(els.iwant,   '128', `לגמור על ה${hisTxt} זוג שלי (כולל על איבר המין)`);
      if (!his) addOpt(els.hewants, '128', 'לגמור עלי (כולל על איבר מין)');
      break;
    }

    case '5': { // אוננות
      if (!his) {
        addOpt(els.iwant, '104', `לעשות ביד ל${hisTxt} זוג שלי`);
      } else {
        addOpt(els.iwant, '105', `לעשות ביד ל${hisTxt} הזוג שלי ללא החדרת אצבעות`);
        addOpt(els.iwant, '150', `לעשות ביד ל${hisTxt} הזוג שלי כולל החדרת אצבעות`);
      }
      if (!my) {
        addOpt(els.hewants, '104', 'לעשות לי ביד');
      } else {
        addOpt(els.hewants, '105', 'לעשות לי ביד ללא החדרת אצבעות לפות שלי');
        addOpt(els.hewants, '160', 'לעשות לי ביד כולל החדרת אצבעות לפות שלי');
      }
      break;
    }

    case '6': // חיבוקים, נגיעות ונשיקות
      addOpt(els.iwant,   '115', `להתנשק צרפתית (עם לשון) עם ה${hisTxt} זוג שלי`);
      addOpt(els.hewants, '115', 'להתנשק איתי צרפתית (עם לשון)');
      addOpt(els.iwant,   '116', `להתנשק ללא לשון עם ה${hisTxt} זוג שלי`);
      addOpt(els.hewants, '116', 'להתנשק איתי ללא לשון');
      addOpt(els.iwant,   '117', `לגעת באיברי המין של ${hisTxt} זוג שלי, ללא החדרה`);
      addOpt(els.hewants, '117', 'לגעת באיברי המין שלי, ללא החדרה');
      addOpt(els.iwant,   '150', `לגעת באיברי המין של ${hisTxt} זוג שלי, כולל החדרה`);
      addOpt(els.hewants, '160', 'לגעת באיברי המין שלי, כולל החדרה');
      addOpt(els.iwant,   '119', `לנשק את איברי המין של ${hisTxt} זוג שלי, ללא החדרת הלשון`);
      addOpt(els.hewants, '119', 'לנשק את איברי המין שלי, ללא החדרת הלשון');
      addOpt(els.iwant,   '150', `לנשק את איברי המין של ${hisTxt} זוג שלי, כולל החדרת הלשון`);
      addOpt(els.hewants, '160', 'לנשק את איברי המין שלי, כולל החדרת הלשון');
      addOpt(els.iwant,   '121', `לחבק את ה${hisTxt} זוג שלי ללא בגדים (עם אופי מיני)`);
      addOpt(els.hewants, '121', 'לחבק אותי ללא בגדים (עם אופי מיני)');
      addOpt(els.iwant,   '129', `לחבק את ה${hisTxt} זוג שלי עם בגדים (עם אופי מיני)`);
      addOpt(els.hewants, '129', 'לחבק אותי עם בגדים (עם אופי מיני)');
      break;
  }
}

/* ─── Calculate result ───────────────────────────────────────── */
function calculate() {
  const myMonthRequired  = isSet(state.myYear)  && state.myYear  !== 19;
  const hisMonthRequired = isSet(state.hisYear) && state.hisYear !== 19;

  const ready =
    isSet(state.mySex)  &&
    isSet(state.myYear) &&
    (!myMonthRequired  || isSet(state.myMonth))  &&
    isSet(state.hisSex) &&
    isSet(state.hisYear) &&
    (!hisMonthRequired || isSet(state.hisMonth)) &&
    isSet(state.act) && state.act !== '' && state.act !== '-1';

  if (!ready) { resetResult(); return; }

  const myAge  = state.myYear  + (myMonthRequired  ? state.myMonth  : 0) / 12;
  const hisAge = state.hisYear + (hisMonthRequired ? state.hisMonth : 0) / 12;

  const eitherUnder14          = myAge < 14 || hisAge < 14;
  const bothOver16             = myAge >= 16 && hisAge >= 16;
  const meOver16               = myAge >= 16;
  const partnerOver16          = hisAge >= 16;
  const over3Years             = Math.abs(myAge - hisAge) >= 3;
  const bothOver18             = myAge >= 18 && hisAge >= 18;

  let specialRelationWarning = false;
  if ((Math.floor(myAge) === 16 || Math.floor(myAge) === 17) && hisAge >= 18) specialRelationWarning = true;
  if ((Math.floor(hisAge) === 16 || Math.floor(hisAge) === 17) && myAge >= 18) specialRelationWarning = true;

  const mySexTxt  = state.mySex  === 0 ? 'בן' : 'בת';
  const hisSexTxt = state.hisSex === 0 ? 'בן' : 'בת';

  const myAgeTxt =
    state.myYear < 13 ? 'מתחת ל-13 שנים' :
    state.myYear > 18 ? 'מעל 19 שנים' :
    `${state.myYear} שנים${state.myMonth === 0 ? '' : ` ו-${state.myMonth} חודשים`}`;

  const hisAgeTxt =
    state.hisYear < 13 ? 'מתחת ל-13 שנים' :
    state.hisYear > 18 ? 'מעל 19 שנים' :
    `${state.hisYear} שנים${state.hisMonth === 0 ? '' : ` ו-${state.hisMonth} חודשים`}`;

  const actEl  = els.act;
  const selOpt = actEl.options[actEl.selectedIndex];
  const actParent = selOpt ? selOpt.parentElement.getAttribute('label') : '';
  const actTxt = actParent === 'אני רוצה...'
    ? `אני רוצה ${selOpt.textContent}`
    : `${hisSexTxt} הזוג שלי רוצה ${selOpt.textContent}`;

  /* ── Evaluate legality ─────────────────────────────────────── */
  const action = state.act;
  let allowed = false;
  let explanation = '';

  const ALLOWED     = 'מותר בהסכמת שני הצדדים';
  const NOT_ALLOWED = 'אסור';

  if (bothOver16) {
    allowed = true;
    explanation = ALLOWED;
  } else {
    const evalStandard = (forbiddenText) => {
      if (eitherUnder14) {
        allowed = false;
        explanation = `${NOT_ALLOWED} ${forbiddenText}`;
      } else if (!meOver16 || !partnerOver16) {
        if (over3Years) {
          allowed = false;
          explanation = `${NOT_ALLOWED} (נחשב למעשה מגונה בפומבי, סעיף 349(ב) לחוק העונשין)`;
        } else {
          allowed = true;
          explanation = ALLOWED;
        }
      } else {
        allowed = true;
        explanation = ALLOWED;
      }
    };

    switch (action) {
      case '128': case '102': case '103': case '105': case '104':
      case '116': case '115': case '117': case '119': case '121': case '129':
        evalStandard('(נחשב למעשה מגונה, סעיף 348(ב) לחוק העונשין)');
        break;
      case '160': case '150':
        if (eitherUnder14) {
          allowed = false;
          explanation = `${NOT_ALLOWED} (נחשב לאונס, סעיף 345(א)(3) לחוק העונשין)`;
        } else if (!meOver16 || !partnerOver16) {
          if (over3Years) {
            allowed = false;
            explanation = `${NOT_ALLOWED} (נחשב לבעילה אסורה בהסכמה, סעיף 346(א)(1) לחוק העונשין)`;
          } else {
            allowed = true;
            explanation = ALLOWED;
          }
        } else {
          allowed = true;
          explanation = ALLOWED;
        }
        break;
      case '161': case '151':
        if (eitherUnder14) {
          allowed = false;
          explanation = `${NOT_ALLOWED} (נחשב לאונס, סעיף 347(ב) לחוק העונשין)`;
        } else if (!meOver16 || !partnerOver16) {
          if (over3Years) {
            allowed = false;
            explanation = `${NOT_ALLOWED} (נחשב למעשה סדום, סעיף 347(א)(1) לחוק העונשין)`;
          } else {
            allowed = true;
            explanation = ALLOWED;
          }
        } else {
          allowed = true;
          explanation = ALLOWED;
        }
        break;
      default:
        resetResult();
        return;
    }
  }

  /* ── Special-relationship notice ───────────────────────────── */
  let notice = '';
  if (specialRelationWarning) {
    notice = 'יש מצבים שבהם יחסים מיוחדים, כגון בין פסיכולוג או עובד סוציאלי לבין מטופל, או בין רב/מורה לתלמיד, הינם אסורים כאשר התלמיד מתחת לגיל 18.';
  } else if (bothOver18) {
    notice = 'יש מצבים שבהם יחסים מיוחדים, כגון בין פסיכולוג לבין מטופל או בין רב למקבל ייעוץ, הינם אסורים גם כאשר שני הצדדים מעל גיל 18.';
  }

  /* ── Render ─────────────────────────────────────────────────── */
  els.resultSummary.innerHTML = `
    <p>אני ${mySexTxt} ${myAgeTxt}.</p>
    <p>${hisSexTxt} הזוג שלי ${hisSexTxt} ${hisAgeTxt}.</p>
    <p>${actTxt}.</p>`;

  const iconAllowed = `<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>`;
  const iconDenied  = `<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;

  els.verdictCard.className = `verdict-card ${allowed ? 'is-allowed' : 'is-denied'}`;
  els.verdictCard.innerHTML = `
    <div class="verdict-title">
      ${allowed ? iconAllowed : iconDenied}
      <span>${allowed ? 'מותר' : 'אסור'}</span>
    </div>
    <p class="verdict-explanation">${explanation}.</p>
    ${notice ? `<p class="verdict-notice">${notice}</p>` : ''}`;

  els.resultSection.hidden = false;
  els.resultSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

  // Analytics (optional)
  try {
    if (typeof gtag !== 'undefined') {
      gtag('event', allowed ? 'allowed' : 'not_allowed', {
        event_category: 'Calculator',
        event_label: `${mySexTxt}-${myAgeTxt}|${hisSexTxt}-${hisAgeTxt}|${actTxt}`,
      });
    }
  } catch (_) {}
}

/* ─── Event wiring ───────────────────────────────────────────── */
function onChange(el, stateKey, transform, after) {
  el.addEventListener('change', () => {
    if (el.value !== '') {
      markError(el, false);
      state[stateKey] = transform ? transform(el.value) : el.value;
      if (after) after();
    } else {
      markError(el, true);
      state[stateKey] = null;
    }
  });
}

onChange(els.mySex,  'mySex',  (v) => parseInt(v, 10), () => showActs());
onChange(els.hisSex, 'hisSex', (v) => parseInt(v, 10), () => showActs());

onChange(els.myYear, 'myYear', (v) => parseInt(v, 10), () => {
  if (state.myYear === 19) {
    els.myMonth.value    = '0';
    els.myMonth.disabled = true;
    markError(els.myMonth, false);
    state.myMonth = 0;
  } else {
    els.myMonth.disabled = false;
  }
  calculate();
});

onChange(els.myMonth, 'myMonth', (v) => parseInt(v, 10), () => calculate());

onChange(els.hisYear, 'hisYear', (v) => parseInt(v, 10), () => {
  if (state.hisYear === 19) {
    els.hisMonth.value    = '0';
    els.hisMonth.disabled = true;
    markError(els.hisMonth, false);
    state.hisMonth = 0;
  } else {
    els.hisMonth.disabled = false;
  }
  calculate();
});

onChange(els.hisMonth, 'hisMonth', (v) => parseInt(v, 10), () => calculate());

onChange(els.actType, 'actType', null, () => showActs());
onChange(els.act,     'act',     null, () => calculate());
